export default "__VITE_ASSET__8052ec2d__"